import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function ProductMovement() {

  const [rows, setRows] = useState([]);
  const [products, setProducts] = useState([]);
  const [rfids, setRfids] = useState([]);
  const [branches, setBranches] = useState([]);

  const [data, setData] = useState({
    product: "",
    rfid_tag: "",
    from_location: "",
    to_location: ""
  });

  useEffect(() => {
    fetchData();
    fetchProducts();
    fetchRfids();
    fetchBranches();
  }, []);

  const fetchData = () => {
    axios.get(baseUrl + "movements/")
      .then(res => {
        setRows(res.data);
      });
  };

  const fetchProducts = () => {
    axios.get(baseUrl + "products/")
      .then(res => {
        setProducts(res.data);
      });
  };

  const fetchRfids = () => {
    axios.get(baseUrl + "rfid-tags/")
      .then(res => {
        setRfids(res.data);
      });
  };

  const fetchBranches = () => {
    axios.get(baseUrl + "branchs/")
      .then(res => {
        setBranches(res.data);
      });
  };

  const inputHandler = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  const formSubmit = () => {

    if (!data.product || !data.rfid_tag || !data.from_location || !data.to_location) {
      Swal.fire("Error", "All fields are required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("product", data.product);
    _formData.append("rfid_tag", data.rfid_tag);
    _formData.append("from_location", data.from_location);
    _formData.append("to_location", data.to_location);
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.post(baseUrl + "movements/", _formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then((response) => {

      if (response.status === 200 || response.status === 201) {

        Swal.fire({
          title: "Movement Recorded",
          icon: "success",
          timer: 2000,
          showConfirmButton: false
        });

        setData({
          product: "",
          rfid_tag: "",
          from_location: "",
          to_location: ""
        });

        fetchData();
      }
    })
    .catch(() => {
      Swal.fire("Error", "Something went wrong", "error");
    });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Confirm",
      text: "Delete this movement record?",
      icon: "warning",
      confirmButtonText: "Yes",
      showCancelButton: true
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + "movements/" + id + "/")
          .then(() => {
            Swal.fire("Deleted", "Record deleted", "success");
            fetchData();
          });
      }
    });
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    {
      field: "product",
      headerName: "Product",
      flex: 1,
      renderCell: (params) => params.row.product?.name || "Unknown"

    },
    {
      field: "rfid_tag",
      headerName: "RFID",
      flex: 1,
      renderCell: (params) => params.row.rfid_tag?.tag_uid || "Unknown"
    },
    {
      field: "from_location",
      headerName: "From",
      flex: 1,
      renderCell: (params) => params.row.from_location?.name || "Unknown"
    },
    {
      field: "to_location",
      headerName: "To",
      flex: 1,
      renderCell: (params) => params.row.to_location?.name || "Unknown"
    },
    { field: "timestamp", headerName: "Time", flex: 1 },

    {
      field: "edit",
      headerName: "Edit",
      renderCell: (params) => (
        <Link
          to={`/product-movements/edit/${params.row.id}`}
          target="_blank"
          className="btn btn-warning"
        >
          Edit
        </Link>
      ),
      width: 120
    },

    {
      field: "delete",
      headerName: "Action",
      renderCell: (params) => (
        <button
          onClick={() => handleDelete(params.row.id)}
          className="btn btn-danger btn-sm ms-1"
        >
          <i className="fa-solid fa-trash-can"></i>
        </button>
      ),
      width: 120
    }
  ];

  return (
    <div className="container mt-4">

      {/* Form */}
      <div className="card p-4 mb-4">
        <h4>Add Product Movement</h4>

        <select
          className="form-control mt-3"
          name="product"
          value={data.product}
          onChange={inputHandler}
        >
          <option value="">Select Product</option>
          {products.map(p => (
            <option key={p.id} value={p.id}>{p.name}</option>
          ))}
        </select>

        <select
          className="form-control mt-3"
          name="rfid_tag"
          value={data.rfid_tag}
          onChange={inputHandler}
        >
          <option value="">Select RFID</option>
          {rfids.map(r => (
            <option key={r.id} value={r.id}>{r.tag_uid}</option>
          ))}
        </select>

        <select
          className="form-control mt-3"
          name="from_location"
          value={data.from_location}
          onChange={inputHandler}
        >
          <option value="">From Location</option>
          {branches.map(b => (
            <option key={b.id} value={b.id}>{b.name}</option>
          ))}
        </select>

        <select
          className="form-control mt-3"
          name="to_location"
          value={data.to_location}
          onChange={inputHandler}
        >
          <option value="">To Location</option>
          {branches.map(b => (
            <option key={b.id} value={b.id}>{b.name}</option>
          ))}
        </select>

        <button
          className="btn btn-success mt-3"
          onClick={formSubmit}
        >
          Submit
        </button>
      </div>

      {/* DataGrid */}
      <div className="card p-3">
        <DataGrid
          sx={{
            boxShadow: 4,
            border: 4,
            borderColor: "primary.light",
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
          }}
          rows={rows}
          columns={columns}
          pageSize={10}
          autoHeight
          components={{ Toolbar: GridToolbar }}
        />
      </div>

    </div>
  );
}

export default ProductMovement;
